module.exports = __webpack_public_path__ + "img/3-Editor-Removing-Frames.6ca5b7c5.gif";